export default __webpack_public_path__ + "static/media/benefit_10.d45bcae4.png";